if (window.Maximize.checkFileNotLoaded()) {
  // Cache parsed section documents per fetch URL (shared across spec section instances).
  const _registerHighlightProductSet = () => {
    Alpine.data("xHighlightProductSet", () => ({
      open: false,
      topPosition: false,
      isDesktop: window.matchMedia("(hover: hover)").matches,
      isShowQuickView: false,
      init() {
        this.$watch("open", (value) => this.calculateHotspotStyle(value));
        window.addEventListener("resize", () => this.__debounce(this.handleResize(), 300));
      },
      __debounce(func, wait) {
        let timeout;
        return function (...args) {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, args), wait);
        };
      },
      handleResize() {
        this.isDesktop = window.matchMedia("(hover: hover)").matches;
      },
      onMouseover() {
        if (this.isDesktop) {
          this.open = true;
        }
      },
      onMouseout() {
        if (this.isDesktop) {
          this.open = false;
        } else {
          this.isShowQuickView = Alpine.store("xQuickView")?.show;
          if (this.isShowQuickView) {
            setTimeout(() => {
              this.isShowQuickView = false;
            }, 300);
          }
        }
      },
      onClickOutside() {
        if (!this.isShowQuickView) {
          this.open = false;
        }
      },
      calculateHotspotStyle(value) {
        if (!value) {
          return;
        }
        const parentElement = this.$root.closest(".highlight-card-container");
        const parentRect = parentElement && parentElement.getBoundingClientRect();
        const contentRef = this.$refs.content;
        const rect = contentRef.getBoundingClientRect();
        if (rect.right >= parentRect.right) {
          this.$root.style.setProperty("--position-translate-x", `${rect.right - parentRect.right + 5}px`);
        }
        if (rect.left < parentRect.left) {
          this.$root.style.setProperty("--position-translate-x", `${rect.left - parentRect.left - 5}px`);
        }
        if (rect.bottom > parentRect.bottom) {
          this.topPosition = true;
        }
      },
      openQuickView(productUrl, productId) {
        if (this.open) {
          Alpine.store("xQuickView") && Alpine.store("xQuickView").load(productId, productUrl, this.$el) && Alpine.store("xQuickView").open();
        } else {
          this.open = !this.open;
        }
      },
    }));
  };

  if (window.Alpine) {
    _registerHighlightProductSet();
  } else {
    document.addEventListener("alpine:init", _registerHighlightProductSet);
  }
}
